import Select from 'react-select';
import { useEffect, useState } from 'react';
import {
  addPayrollConditions,
  getPayrollConditionList,
  deletePayrollCondition
} from '@store/HR/Payroll/PayrollConditionsSlice';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useParams } from 'react-router-dom';

import { getOrganizations } from '@store/HR/Organizations/organizationSlice';
import { getLocations } from '@store/HR/HRSetting/locationSlice';
import { getGrades } from '@store/HR/HRSetting/jobgradeSlice';
import { getPositions } from '@store/HR/HRSetting/positionSlice';
import { getGroupEmp } from '@store/HR/HRSetting/groupEmpSlice';
import { getJobs } from '@store/HR/HRSetting/jobSlice';
import { getPayrolls } from '@store/HR/Payroll/PayrollSlice';
import NtxTable from '@components/DataTable/NtxTable';
import confirmAction from '@components/Shared/Alert/confirmAction';
import useGetPayrollCondition from '@hooks/Payrolls/useGetPayrollCondition';
import { Card, CardBody, CardFooter, CardHeader } from '@components/card/card';
import { PayrollConditionsSchema } from '@pages/ValidationForm/validationSchema';

const Conditions = () => {
  const { id: payrollId } = useParams();
  const [dynamicData, setDynamicData] = useState([]);

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const Options = [
    {
      value: 'DEPARTMENT',
      label: i18n.language === 'en' ? 'Department' : 'الإدارة',
      staticType: 'Static'
    },
    {
      value: 'LOCATION',
      label: i18n.language === 'en' ? 'Location' : 'الموقع',
      staticType: 'Static'
    },
    {
      value: 'GRADE',
      label: i18n.language === 'en' ? 'Grade' : 'الدرجة الوظيفية',
      staticType: 'Static'
    },
    { value: 'JOB', label: i18n.language === 'en' ? 'JOB' : 'الوظيفة', staticType: 'Static' },
    {
      value: 'POSITION',
      label: i18n.language === 'en' ? 'Position' : 'المنصب',
      staticType: 'Static'
    },
    {
      value: 'GROUP',
      label: i18n.language === 'en' ? 'Group' : 'مجموعة الموظفين',
      staticType: 'Static'
    },
    // {
    //   value: 'PAYROLL',
    //   label: i18n.language === 'en' ? 'Payroll' : 'الراتب',
    //   staticType: 'Static'
    // }
  ];

  const formik = useFormik({
    initialValues: {
      name: '',
      name2: '',
      payrollId: payrollId,
      code: '',
      parameterOne: '',
      description: '',
      staticType: ''
      //!!
      // multiSelect: ''
    },
    enableReinitialize: true,
    validationSchema: PayrollConditionsSchema(t),
    onSubmit: values => {
      dispatch(
        addPayrollConditions({
          name: values.name,
          name2: values.name2,
          payrollId: payrollId,
          code: values.code,
          parameterOne: values.parameterOne,
          // parameterOne: values.parameterOne,
          description: values.description,
          staticType: values.staticType
        })
      )
        .unwrap()
        .then(res => {
          if (res.succeeded) {
            formik.resetForm();
            CustomAlert({ action: 'Add' });
            dispatch(getPayrollConditionList(payrollId ?? ''));
          } else {
            CustomAlert({ action: 'Error' });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
          console.log(error);
        })
        .finally(() => formik.setSubmitting(false));
    }
  });
  const { values, errors, setFieldValue, touched, handleChange, isSubmitting } = formik;
  // console.log(errors);

  async function handleSelectChange(option: any) {
    const { staticType, value } = option;

    // setFieldValue('Condition', option.value);
    // setFieldValue('conditionType', staticType === 'Dynamic' ? 'DYNAMIC' : 'STATIC');

    setFieldValue('multiSelect', ''); //
    setFieldValue('staticType', value);

    setDynamicData([]);
    await handleStaticType(value);
  }

  async function handleStaticType(value: any) {
    try {
      let data;
      switch (value) {
        case 'DEPARTMENT':
          data = await dispatch(getOrganizations()).unwrap();
          data = data?.filter((f: any) => f.organizationInformation === 'HR_ORG');
          break;
        case 'LOCATION':
          data = await dispatch(getLocations()).unwrap();
          break;
        case 'GRADE':
          data = await dispatch(getGrades()).unwrap();
          break;
        case 'POSITION':
          data = await dispatch(getPositions()).unwrap();
          break;
        case 'GROUP':
          data = await dispatch(getGroupEmp()).unwrap();
          break;
        case 'JOB':
          data = await dispatch(getJobs()).unwrap();
          break;
        case 'PAYROLL':
          data = await dispatch(getPayrolls()).unwrap();
          break;
        default:
          setDynamicData([]);
          return;
      }

      const transformedData = data?.map((item: any) => ({
        value: item.id,
        label: i18n.language === 'en' ? item.name : item.name2
      }));
      setDynamicData(transformedData);
    } catch (error) {
      console.error('Error fetching static data:', error);
    }
  }

  const handleMultiSelectChange = (selectedOptions: any) => {
    const formattedOptions = selectedOptions?.map((option: any) => option.value).join(',');
    setFieldValue('parameterOne', formattedOptions);
  };

  function GetLabelName() {
    var lableName = '';
    switch (values.staticType) {
      case 'DEPARTMENT':
        lableName = t('Departments');
        break;
      case 'LOCATION':
        lableName = t('Locations');
        break;
      case 'GRADE':
        lableName = t('Grade');
        break;
      case 'POSITION':
        lableName = t('Positions');
        break;
      case 'GROUP':
        lableName = t('Staffgroup');
        break;
      case 'JOB':
        lableName = t('Jobs');
        break;
      case 'PAYROLL':
        lableName = t('Payroll');
        break;
      default:
        lableName = t('...');
        return;
    }

    return lableName;
  }

  // console.log(values);

  return (
    <>
      <Card className='mt-3'>
        <CardHeader className='border-bottom'>
          <h6 className='mb-0'>
            <i className='fas fa-plus-circle me-2 text-theme'></i>
            {t('إضافة شرط جديد')}
          </h6>
        </CardHeader>
        <CardBody>
          <Form onSubmit={formik.handleSubmit}>
            <div className='row'>
              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('LocalName')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='name2'
                    onChange={handleChange}
                    value={values.name2 || ''}
                    isInvalid={!!(touched.name2 && errors.name2)}
                  />
                  <div className='text-danger small'>{touched.name2 && formik.errors.name2}</div>
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('GlobalName')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='name'
                    onChange={handleChange}
                    value={values.name || ''}
                    isInvalid={!!(touched.name && errors.name)}
                  />
                  <div className='text-danger small'>{touched.name && formik.errors.name}</div>
                </div>
              </div>
              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Code')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='code'
                    onChange={handleChange}
                    value={values.code || ''}
                    isInvalid={!!(touched.code && errors.code)}
                  />
                  <div className='text-danger small'>{touched.code && formik.errors.code}</div>
                </div>
              </div>

              <div className='col-xl-3'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Condition')}</label>

                  <Select
                    classNamePrefix='react-select'
                    // isLoading={loading}
                    isSearchable={true}
                    // isClearable
                    options={Options}
                    onChange={option => handleSelectChange(option)}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                    }}
                  />
                  <div className='text-danger small'>{touched.staticType && errors.staticType}</div>
                </div>
              </div>

              <div className='col-xl-6'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{GetLabelName() ?? <>&nbsp;</>}</label>
                  <Select
                    isSearchable
                    isMulti
                    options={dynamicData}
                    classNamePrefix='react-select'
                    name='multiSelect'
                    value={
                      values.parameterOne?.split(',')?.map(value => {
                        return dynamicData?.find((option: any) => option.value === value);
                      }) || null
                    }
                    onChange={handleMultiSelectChange}
                    placeholder={i18n.language === 'ar' ? '' : ''}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                    }}
                  />
                  <div className='text-danger'>{touched.parameterOne && errors.parameterOne}</div>
                </div>
              </div>

              <div className='col-xl-6'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('Note')}</label>
                  <Form.Control
                    className='form-control'
                    type='text'
                    autoComplete='off'
                    name='description'
                    onChange={handleChange}
                    value={values.description || ''}
                    isInvalid={!!(touched.description && errors.description)}
                  />
                  <div className='text-danger small'>
                    {touched.description && formik.errors.description}
                  </div>
                </div>
              </div>
            </div>

            <div className='text-center mt-2'>
              <div className='d-flex justify-content-between gap-2'>
                <button
                  disabled={formik.isSubmitting}
                  type='submit'
                  className='btn btn-lg btn-theme mb-1 w-100 rounded-1'
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fas fa-plus fa-lg fa-fw me-2'></i>
                  )}
                  {t('Add')}
                </button>
                <button
                  type='button'
                  className='btn btn-lg  btn-default mb-1 w-100 rounded-1'
                  data-bs-dismiss='modal'
                  id='closeModalJob'
                >
                  <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </Form>
        </CardBody>
      </Card>
      <Card className='mt-3'>
        <CardHeader className='border-bottom'>
          <h6 className='mb-0'>
            <i className='fas fa-list me-2 text-theme'></i>
            {t('قائمة الشروط')}
          </h6>
        </CardHeader>
        <CardBody>
          <List />
        </CardBody>
      </Card>
    </>
  );
};

export default Conditions;

const List = () => {
  const { id: payrollId } = useParams();

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const { PayrollConditionList: data, loading, error } = useGetPayrollCondition(payrollId);
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const columns = [
    { title: t('Name'), key: 'Name' },
    // { title: t('payrollName'), key: 'payrollName' },
    { title: t('Code'), key: 'code' },
    { title: t('Type'), key: 'staticType' },
    { title: t('Description'), key: 'description' },

    { title: t(''), key: 'action', className: 'text-end', sortable: false }
  ];

  const tableData = data?.map(item => {
    // let rowClass;

    return {
      Name: i18n.language === 'en' ? item.name : item.name2,
      payrollName: i18n.language === 'en' ? item.payrollName : item.payrollName2,
      code: item.code,
      description: item.description,
      staticType: item.staticType,
      action: (
        <button
          type='button'
          className='btn btn-sm btn-outline-danger'
          onClick={() => handleDelete(item.id)}
        >
          <i className='fas fa-lg fa-trash-alt'></i>
        </button>
      )
    };
  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

  const handleDelete = async (Id: any) => {
    const isConfirm = await confirmAction('هل أنت متأكد من عملية الحذف');
    if (!isConfirm) {
      return;
    }

    var res = await dispatch(deletePayrollCondition(Id)).unwrap();
    // debugger;
    if (res.succeeded && res.data) {
      CustomAlert({ action: 'Delete' });
      dispatch(getPayrollConditionList(payrollId ?? ''));
    } else {
      CustomAlert({ action: 'Error' });
    }
  };

  return (
    <>
      <div className='mt-3'>
        <NtxTable
          data={tableData || []}
          columns={columns}
          dataPerPage={4}
          theadClass=''
          tableClass='table text-nowrap table-hover '
          // enableSearch
          // showRecordsSelector
        />
      </div>
    </>
  );
};
